import Box from '@mui/material/Box';
import {StyledflexSpacebetween, StyledGridContainer, StyledLeadContainer} from '../../Components/Styled/index';
import { useSelector } from 'react-redux';
import { ACTIVE_STATUS, handleValidateCodevalue, PRODUCT_STATUS, PRODUCT_TYPE } from '../../Utility/constant';
import { WhoColumns } from '../../Components/WhoColumns';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import './product.css';

const SearchProduct = ({handleSelectAutocomplete,entityDetails , handleOnChange}) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const productStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const productTypeData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const merchantData = useSelector(state => state?.merchant?.merchant);
  

    

  return (
        <Box className="product-search-fields">
            <StyledGridContainer>
                <TextFiledWithLabel 
                id="id" 
                label={handleValidateCodevalue(internationalise,'PROD_SEARCH_PRODUCT_ID')} 
                name="id"
                type = "number"
                handleOnChange={handleOnChange}
                value={entityDetails?.id}
                />
                <TextFiledWithLabel 
                id="searchname" 
                label={handleValidateCodevalue(internationalise,'PROD_SEARCH_PRODUCT_NAME')} 
                name="name"
                handleOnChange={handleOnChange}
                value={entityDetails?.name}
                />
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        name= "status"
                        value= {entityDetails?.status || ""}
                        isStatic={false}
                        optionMenuItem={productStatusData}
                        label={handleValidateCodevalue(internationalise,'PRODUCT_STATUS')}
                        handleOnChange={handleOnChange}
                    />
                    </StyledGridContainer>
                    <StyledGridContainer>
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        value={entityDetails?.type}
                        name="type"
                        label={handleValidateCodevalue(internationalise,'PRODUCT_TYPE')}
                        handleOnChange={handleOnChange}
                        optionMenuItem={productTypeData}
                        isStatic={false}
                    />
                    {specificRolePermission?.isVendorView &&
                    <AutoCompleteComponent
                        optionSet = {merchantData}
                        value={entityDetails?.selectedVendor || null}
                        name = "vendorId"
                        placeholder={handleValidateCodevalue(internationalise,'PROD_EDIT_VENDOR')}
                        label={handleValidateCodevalue(internationalise,'PROD_EDIT_VENDOR')}       
                        onChange={(e, val) => handleSelectAutocomplete(e, val, "selectedVendor")}
                    />}
            </StyledGridContainer>
            <StyledflexSpacebetween>
                  <div className='date-container-search'>
                <TextFiledWithLabel 
                id="searchname" 
                label={handleValidateCodevalue(internationalise,'PROD_SEARCH_PRICE_FROM')} 
                name="priceLow"
                handleOnChange={handleOnChange}
                value={entityDetails?.priceLow}
                />
                <TextFiledWithLabel
                id="searchname" 
                label={handleValidateCodevalue(internationalise,'PROD_SEARCH_PRICE_TO')} 
                name="priceHigh"        
                handleOnChange={handleOnChange}
                value={entityDetails?.priceHigh}
                />
        </div>
            </StyledflexSpacebetween>
                <WhoColumns
                searchState={entityDetails}
                handleOnChange={handleOnChange}

                />
        </Box>
  );
}

export default SearchProduct;
